import {
  Box,
  Flex,
  VStack,
  Text,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import {
  FiHome,
  FiUsers,
  FiFileText,
  FiAlertTriangle,
  FiMessageSquare,
  FiDollarSign,
  FiMail,
  FiUserCheck,
  FiArrowLeft,
} from 'react-icons/fi';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/admin', icon: FiHome, exact: true },
  { label: 'Users', path: '/admin/users', icon: FiUsers },
  { label: 'Verifications', path: '/admin/verifications', icon: FiUserCheck },
  { label: 'Tasks', path: '/admin/tasks', icon: FiFileText },
  { label: 'Disputes', path: '/admin/disputes', icon: FiAlertTriangle },
  { label: 'Support', path: '/admin/support', icon: FiMessageSquare },
  { label: 'Payments In', path: '/admin/payments/incoming', icon: FiDollarSign },
  { label: 'Payments Out', path: '/admin/payments/outgoing', icon: FiDollarSign },
  { label: 'Email', path: '/admin/email', icon: FiMail },
];

function SidebarLink({ item, isActive }) {
  const activeBg = useColorModeValue('orange.50', 'orange.900');
  const activeColor = useColorModeValue('orange.600', 'orange.200');
  const hoverBg = useColorModeValue('gray.50', 'gray.700');

  return (
    <Box
      as={Link}
      to={item.path}
      display="flex"
      alignItems="center"
      gap={3}
      px={3}
      py={2}
      rounded="md"
      fontSize="sm"
      fontWeight={isActive ? 'semibold' : 'normal'}
      color={isActive ? activeColor : undefined}
      bg={isActive ? activeBg : 'transparent'}
      _hover={{ bg: isActive ? activeBg : hoverBg }}
      transition="all 0.15s"
    >
      <Icon as={item.icon} boxSize={4} />
      {item.label}
    </Box>
  );
}

export default function AdminLayout() {
  const location = useLocation();
  const sidebarBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.path;
    return location.pathname.startsWith(item.path);
  };

  return (
    <Flex minH="calc(100vh - 64px)">
      {/* Sidebar */}
      <Box
        w="220px"
        bg={sidebarBg}
        borderRight="1px"
        borderColor={borderColor}
        py={4}
        px={3}
        flexShrink={0}
        position="sticky"
        top="64px"
        h="calc(100vh - 64px)"
        overflowY="auto"
      >
        <VStack spacing={1} align="stretch">
          <Text fontSize="xs" fontWeight="bold" color="gray.400" textTransform="uppercase" px={3} mb={2}>
            Admin Panel
          </Text>
          {NAV_ITEMS.map((item) => (
            <SidebarLink key={item.path} item={item} isActive={isActive(item)} />
          ))}
          <Box h={4} />
          <Box
            as={Link}
            to="/tasks"
            display="flex"
            alignItems="center"
            gap={3}
            px={3}
            py={2}
            rounded="md"
            fontSize="sm"
            color="gray.500"
            _hover={{ bg: useColorModeValue('gray.50', 'gray.700') }}
          >
            <Icon as={FiArrowLeft} boxSize={4} />
            Back to App
          </Box>
        </VStack>
      </Box>

      {/* Main content */}
      <Box flex={1} p={6} maxW="calc(100% - 220px)">
        <Outlet />
      </Box>
    </Flex>
  );
}
